var _rect, _line, _line2, _line3, _line4, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideseatCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#0d1a2a"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 640,
    y2: 60,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 640,
    y2: 300,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 213,
    y1: 0,
    x2: 213,
    y2: 360,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.04
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 426,
    y1: 0,
    x2: 426,
    y2: 360,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160,220 Q220,160 280,175 Q340,190 400,145 Q450,115 490,130",
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    strokeDasharray: "6 4",
    opacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 220,
    r: 18,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 220,
    r: 6,
    fill: "#4a7a3a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 130,
    r: 14,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2,
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 130,
    r: 5,
    fill: "#fff",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 178,
    r: 5,
    fill: "#4a7a3a",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 220,
    r: 32,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 0.8,
    opacity: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 220,
    r: 48,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 0.5,
    opacity: 0.12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 318,
    fontFamily: "Georgia, serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.25,
    letterSpacing: 3
  }, "SIDESEAT \xB7 2026")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 42,
    fontFamily: "Georgia, serif",
    fontSize: 9,
    fill: "#4a7a3a",
    letterSpacing: 4,
    opacity: 0.8
  }, "COMPANION PLATFORM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideseatCover);
export default __webpack_public_path__ + "static/media/sideseat-cover.bbc861aa8e8e9c6421f39e247655ff3b.svg";
export { ForwardRef as ReactComponent };